import { render, staticRenderFns } from "./ItemPL_Items.vue?vue&type=template&id=442e37de"
import script from "./ItemPL_Items.vue?vue&type=script&lang=js"
export * from "./ItemPL_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports